import { render } from "./sticky-top.vue?vue&type=template&id=9b319a40&scoped=true"
const script = {}

import "./sticky-top.vue?vue&type=style&index=0&id=9b319a40&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b319a40"]])

export default __exports__